import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./HomePage.css";

const HomePage = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboard";

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated()) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  useEffect(() => {
    if (location.state?.registrationSuccess) {
      setSuccessMessage(location.state.message || "Account created successfully.");
    }
  }, [location.state]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const result = await login(formData.email, formData.password);

      if (result.success) {
        // Redirect to dashboard or the page they were trying to access
        navigate(from, { replace: true });
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="home-page">
      <div className="split-container">
        {/* Left Side - Login Form */}
        <div className="left-section">
          <div className="login-container">
            <div className="login-header">
              <h1>Welcome Back</h1>
              <p>Sign in to your account</p>
            </div>

            <form
              className="login-form"
              onSubmit={handleSubmit}>
              {error && <div className="error-message">{error}</div>}
              {successMessage && (
                <div className="success-message">{successMessage}</div>
              )}

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  disabled={isLoading}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter your password"
                  disabled={isLoading}
                  required
                />
              </div>

              <div className="form-options">
                <label className="remember-me">
                  <input type="checkbox" />
                  <span>Remember me</span>
                </label>
                <Link
                  to="/forgot-password"
                  className="forgot-password">
                  Forgot Password?
                </Link>
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={isLoading}>
                {isLoading ? (
                  <span className="button-content">
                    <span className="spinner-small"></span>
                    Signing In...
                  </span>
                ) : (
                  "Sign In"
                )}
              </button>

              <div className="signup-link">
                <p>
                  Need an account? <Link to="/register">Register</Link>
                </p>
              </div>
            </form>
          </div>
        </div>

        {/* Vertical Divider */}
        <div className="vertical-divider"></div>

        {/* Right Side - Law Themed Image */}
        <div className="right-section">
          <div className="image-container">
            <div className="law-themed-content">
              <img
                src="/big.png"
                alt="LineaBlu Logo"
                className="hero-logo"
              />
              <h2>Center of Excellence</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
